import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ScreenSizes } from '../../../classes/screen-sizes.class';
import { billingScope } from '../../../consts';
import { capitalize } from '../../../lib/capitalize';
import { DialogService } from '../../../services/dialog.service';
import { PermissionService } from '../../../services/permission.service';
import { PricingService } from '../../../services/pricing.service';
import { StateService } from '../../../services/state.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ClickTrackDirective } from '../../../shared/directives/click-track.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';

@Component({
  selector: 'app-pro-tag',
  templateUrl: './pro-tag.component.html',
  styleUrls: ['./pro-tag.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TooltipDirective, SvgComponent, UpperCasePipe, CapitalizePipe, ClickTrackDirective],
})
export class ProTagComponent implements OnInit {
  public state = inject(StateService);
  private dialog = inject(DialogService);
  private permissionService = inject(PermissionService);
  private pricingService = inject(PricingService);

  text: string;
  @Input() center: boolean;
  @Input() tenantId: string;
  @Input() scope: billingScope;
  @Input() noTop: boolean;
  @Input() small: boolean = ScreenSizes.screenSize() === 'mobile';
  @Input({ required: true }) location: string;
  allowPricingLink: boolean;
  productName = signal<string>(undefined);
  productNameShort = computed<string>(() => {
    const productName = this.productName();
    if (productName === 'enterprise') return 'ent';
    return productName;
  });
  canStartTrial = signal(this.pricingService.canStartTrial());

  ngOnInit() {
    if (!this.state.plan) return;
    this.allowPricingLink = this.permissionService.shouldRedirectToPricingPage(this.tenantId);
    if (this.scope) this.productName.set(this.permissionService.getMinPlanForScope(this.scope));
    if (!this.productName()) this.productName.set('pro');

    const trialLength = this.pricingService.getTrialLengthDays();

    if (this.canStartTrial() && trialLength) {
      this.text = 'Start your free trial!';
    } else {
      this.text = `Upgrade to Picflow ${capitalize(this.productName())}!`;
    }
  }

  closeDialogs() {
    this.dialog.close();
  }
}
